import { render, staticRenderFns } from "./UnidadeTable.vue?vue&type=template&id=a62fd0ce&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./UnidadeTable.vue?vue&type=style&index=0&id=a62fd0ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62fd0ce",
  null
  
)

export default component.exports